
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-car",
      function () {
        return require("private-next-pages/sell-car.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-car"])
      });
    }
  